module.exports = __webpack_public_path__ + "img/bag.54e79056.svg";